import { Pipe, PipeTransform } from '@angular/core';
import { format, parseISO } from 'date-fns';

@Pipe({
  name: 'parseDate'
})
export class ParseDatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (value) {
      return format(parseISO(value), 'dd-MM-yyyy');
    }
  }
}
